<template lang='pug'>
//- Course-Main
div(:class='$style[`cc-course-menu`]')
  template(v-if='!preloading')
    div(v-if='draftData' :class='$style[`cc-course-banner`]')
      div(
        v-if='draftData.photo_cover'
        :class='$style[`cc-course-banner-blur-bg`]'
        :style='`background-size: cover; background-position: center; background-repeat: no-repeat; background-image: url(${SERVER_STATIC_URL}media/${draftData.photo_cover})`')
      div(
        v-else
        :class='$style[`cc-course-banner-blur-bg`]'
        :style='`background-size: cover; background-position: center; background-repeat: no-repeat; background-image: url(${SERVER_STATIC_URL}media/originSrc/noimage.webp)`')

      div(
        :title='draftData.title'
        :class='$style[`cc-course-banner-content`]')
        div(:class='$style[`cc-course-banner-left`]')
          figure(
            v-if='draftData.photo_cover'
            :class='$style[`cc-course-banner-left-photo`]')
            img(:src='`${SERVER_STATIC_URL}media/${draftData.photo_cover}`' width='100%')
          figure(
            v-else
            :class='$style[`cc-course-banner-left-photo`]'
            :style='`background-image: url(${SERVER_STATIC_URL}media/originSrc/noimage.webp)`')

        div(:class='$style[`cc-course-banner-right`]')
          div(:class='$style[`cc-course-banner-right-wrap`]')
            div(:class='$style[`cc-course-banner-status`]')
              ul(:class='$style[`cc-course-banner-status-tag`]')
                li(:class='[$style[`cc-course-banner-status-tag-li`], $style[`draft-course`]]') 即將上架新課程
              header.font-bold(:class='$style[`cc-course-banner-status-header`]') {{ draftData.title }}
              span(:class='$style[`cc-course-banner-status-describe`]') {{ draftData.info }}

            div(:class='$style[`cc-course-banner-info`]')
              div(:class='$style[`cc-course-banner-info-avatar`]')
                figure(:class='$style[`cc-course-banner-info-avatar-photo`]')
                  img(
                    :src='`${SERVER_STATIC_URL}media/${draftData.author_thumbSrc}`'
                    width='100%'
                    height='100%')
                span.font-medium(:class='$style[`cc-course-banner-info-avatar-name`]') {{ draftData.author_name }}
            //- div(:class='$style[`cc-course-banner-view`]')
            //-   IconView(:size='24')
            //-   span.font-bold {{ draftData.read_count }}
            div(:class='$style[`cc-course-banner-control`]')
              div(:class='$style[`cc-course-banner-control-btn`]') 敬請期待


    div(v-else :class='$style[`cc-course-banner`]')
      div(
        v-if='latestData.photo_cover'
        :class='$style[`cc-course-banner-blur-bg`]'
        :style='`background-size: cover; background-position: center; background-repeat: no-repeat; background-image: url(${SERVER_STATIC_URL}media/${latestData.photo_cover})`')
      div(
        v-else
        :class='$style[`cc-course-banner-blur-bg`]'
        :style='`background-size: cover; background-position: center; background-repeat: no-repeat; background-image: url(${SERVER_STATIC_URL}media/originSrc/noimage.webp)`')

      router-link(
        tabindex='0' :aria-label='latestData.title'
        :to='`/course/${latestData.course_id}`'
        :class='$style[`cc-course-banner-content`]')
        div(:class='$style[`cc-course-banner-left`]')
          figure(
            v-if='latestData.photo_cover'
            :class='$style[`cc-course-banner-left-photo`]')
            img(:src='`${SERVER_STATIC_URL}media/${latestData.photo_cover}`' width='100%')
          figure(
            v-else
            :class='$style[`cc-course-banner-left-photo`]'
            :style='`background-image: url(${SERVER_STATIC_URL}media/originSrc/noimage.webp)`')

        div(:class='$style[`cc-course-banner-right`]')
          div(:class='$style[`cc-course-banner-right-wrap`]')
            div(:class='$style[`cc-course-banner-status`]')
              ul(:class='$style[`cc-course-banner-status-tag`]')
                li(:class='[$style[`cc-course-banner-status-tag-li`], $style[`latest-course`]]') 最新課程
                //- li(:class='$style[`cc-course-banner-status-tag-li`]') 化療
                //- li(:class='$style[`cc-course-banner-status-tag-li`]') 新手攻略
              header.font-bold(:class='$style[`cc-course-banner-status-header`]') {{ latestData.title }}
              span(:class='$style[`cc-course-banner-status-describe`]') {{ latestData.info }}

            div(:class='$style[`cc-course-banner-info`]')
              div(:class='$style[`cc-course-banner-info-avatar`]')
                figure(:class='$style[`cc-course-banner-info-avatar-photo`]')
                  img(
                    :src='`${SERVER_STATIC_URL}media/${latestData.author_thumbSrc}`'
                    width='100%'
                    height='100%')
                span.font-medium(:class='$style[`cc-course-banner-info-avatar-name`]') {{ latestData.author_name }}
            //- div(:class='$style[`cc-course-banner-view`]')
            //-   IconView(:size='24')
            //-   span.font-bold {{ latestData.read_count }}
            div(:class='$style[`cc-course-banner-control`]')
              div(:class='$style[`cc-course-banner-control-btn`]') 瀏覽課程內容



    div(:class='$style[`cc-course-content`]')
      div(:class='$style[`cc-course-filter`]')
        div(:class='$style[`cc-course-filter-wrap`]')
          router-link.font-medium(
            v-for='items, index in menuList'
            tabindex='0' :aria-label='items'
            :to='items === `全部` ? `/course` : `/course?f=${items}`'
            :key='index'
            exact=true
            :active-class='$style[`cc-selected`]'
            :class='$style[`cc-course-filter-btn`]'
            @click.native='handleClickSwitchQuery(items)')
            span {{ items }}

      div(v-if='reloading' :class='$style[`cc-course-list`]')
        div(:class='$style[`cc-course-list-wrap`]')
          header(:class='$style[`cc-skeleton-header`]')
            span
          ul(:class='$style[`cc-course-skeleton-ul`]')
            li(v-for='n in 6' :class='$style[`cc-course-skeleton-li`]')
              div(:class='$style[`cc-skeleton-main`]')
                .skeleton-preload(:class='$style[`cc-skeleton-main-thumb`]')
                .skeleton-preload(:class='$style[`cc-skeleton-main-title`]')

      div(v-else :class='$style[`cc-course-list`]')
        div(:class='$style[`cc-course-list-wrap`]')
          div(:class='$style[`cc-course-list-block`]')
            div(:class='$style[`cc-course-content-infinite`]')
              div(:class='$style[`cc-course-content-block-head`]')
                div(v-if='switchQuery === `全部`' :class='$style[`cc-course-content-block-left`]')
                  header.font-bold(:class='$style[`cc-course-content-block-head-title`]') 所有課程
                  span(:class='$style[`cc-course-content-block-head-subtitle`]') 多元癌症課程學到飽

                div(v-else-if='switchQuery === `新手攻略`' :class='$style[`cc-course-content-block-left`]')
                  header.font-bold(:class='$style[`cc-course-content-block-head-title`]') 新手攻略
                  span(:class='$style[`cc-course-content-block-head-subtitle`]') 第一次罹癌推薦必讀

                div(v-else-if='switchQuery === `對症好治療`' :class='$style[`cc-course-content-block-left`]')
                  header.font-bold(:class='$style[`cc-course-content-block-head-title`]') 對症好治療
                  span(:class='$style[`cc-course-content-block-head-subtitle`]') 幫助順利完成治療

                div(v-else-if='switchQuery === `預防不復發`' :class='$style[`cc-course-content-block-left`]')
                  header.font-bold(:class='$style[`cc-course-content-block-head-title`]') 預防不復發
                  span(:class='$style[`cc-course-content-block-head-subtitle`]') 落實保健，癌細胞掰掰

                div(v-else-if='switchQuery === `健康生活`' :class='$style[`cc-course-content-block-left`]')
                  header.font-bold(:class='$style[`cc-course-content-block-head-title`]') 健康生活
                  span(:class='$style[`cc-course-content-block-head-subtitle`]') 享受健康、自在好生活


              div(:class='$style[`cc-course-content-item`]')
                ul(v-if='courseData.length' :class='$style[`cc-course-content-item-ul`]')
                  li(v-for='items, index in courseData' :class='$style[`cc-course-content-item-li`]' :key='index')
                    courseMenuItem(:itemData='items')

                div(v-else :class='$style[`cc-course-content-item-empty`]')
                  div.font-medium(:class='$style[`cc-course-content-item-empty-tips`]') 尚未推出，敬請期待!

                //- LazyLoad
                infinite-loading(:identifier='infiniteId' @infinite='infiniteHandler')
                  div(slot='spinner')
                    IconLoading(
                      slot='spinner'
                      :size='30'
                      :color='`#b1b1b1`')

                  div.infinite-scroll-slot(slot='no-more' style='padding-top: 15px;')
                    span.infinite-scroll-slot-noMore 沒有更多資料

                  div.infinite-scroll-slot(slot='no-results' style='padding-top: 15px;')
                    span.infinite-scroll-slot-noMore 沒有更多資料

          //- div(v-if='courseOverview.b.count' :class='$style[`cc-course-list-block`]')
          //-   courseMenuInfinite(:courseData='courseOverview.b.results' :loadQuery='menuList[2]')
          //- div(v-if='courseOverview.c.count' :class='$style[`cc-course-list-block`]')
          //-   courseMenuInfinite(:courseData='courseOverview.c.results' :loadQuery='menuList[3]')
          //- div(v-if='courseOverview.d.count' :class='$style[`cc-course-list-block`]')
          //-   courseMenuInfinite(:courseData='courseOverview.d.results' :loadQuery='menuList[4]')

        //- div(v-else :class='$style[`cc-course-list-wrap`]')
        //-   div(:class='$style[`cc-course-list-block`]')
        //-     courseMenuInfinite(:courseData='courseData' :loadQuery='switchQuery')

  template(v-else)
    div(:class='$style[`cc-course-banner`]')
      div(:class='$style[`cc-course-banner-blur-bg`]')

      div(:class='$style[`cc-course-banner-content`]')
        div(:class='$style[`cc-course-banner-left`]')
          .skeleton-preload(:class='$style[`cc-course-banner-left-photo`]')

        div(:class='$style[`cc-course-banner-right`]' )
          div(
            :class='$style[`cc-course-banner-right-wrap`]'
            style='width: 100%;')
            div(:class='$style[`cc-course-banner-status`]')
              header.skeleton-preload(
                :class='$style[`cc-course-banner-status-header`]'
                style='height: 20px; border-radius: 10px;')
              .skeleton-preload(
                :class='$style[`cc-course-banner-status-describe`]'
                style='width: 70%; height: 16px; border-radius: 10px; margin-top: 10px;')

    div(:class='$style[`cc-course-content`]')
      div(:class='$style[`cc-course-list`]')
        div(:class='$style[`cc-course-list-wrap`]')
          ul(:class='$style[`cc-course-skeleton-ul`]')
            li(v-for='n in 3' :class='$style[`cc-course-skeleton-li`]')
              div(:class='$style[`cc-skeleton-main`]')
                .skeleton-preload(:class='$style[`cc-skeleton-main-thumb`]')
                .skeleton-preload(:class='$style[`cc-skeleton-main-title`]')




</template>

<script>
import axios from 'axios';
import { mapGetters, mapMutations } from 'vuex';
// import { debounce } from 'debounce';

import IconLoading from '../../icon/Loading';
import IconView from '../../icon/View';
// import courseMenuSwiper from './CourseMenuSwiper';
// import courseMenuInfinite from './CourseMenuInfinite';
import CourseMenuItem from './CourseMenuItem';

import {
  putLoadCourseList,
} from '../../../js/restapi';

export default {
  metaInfo() {
    return {
      title: '線上課程',
      titleTemplate: '%s | Cancell 醫抗癌',
      meta: [{
        name: 'og:url',
        content: this.$route.query.f ? `https://cancell.tw/course?f=${this.$route.query.f}` : 'https://cancell.tw/course',
      }],
      link: [{
        rel: 'canonical',
        href: this.$route.query.f ? `https://cancell.tw/course?f=${this.$route.query.f}` : 'https://cancell.tw/course',
      }],
    };
  },

  components: {
    IconLoading,
    IconView,
    // courseMenuSwiper,
    // courseMenuInfinite,
    CourseMenuItem
  },

  data() {
    return {
      preloading: true,
      reloading: true,
      pageSize: 10,
      pageIndex: 1,
      switchQuery: this.$route.query.f ? this.$route.query.f : '全部',
      menuList: ['全部', '新手攻略', '對症好治療', '預防不復發', '健康生活'],
      courseData: [],
      // courseOverview: {},
      latestData: {},
      draftData: {},
      infiniteId: +new Date(),
    };
  },

  created() {
    this.$route.query.f ? this.handleClickSwitchQuery(this.switchQuery) : this.handleClickSwitchQuery('全部');
    // if (this.$route.query.f) {
    //   this.handleClickSwitchQuery(this.switchQuery);
    // } else {
    //   this.handleClickSwitchQuery('全部');
    // }
  },

  // mounted() {},

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
      changePopDeleteAskStatus: 'global/POPDELETE_ASK_STATUS',
      changePopQuestionStatus: 'global/POPQUESTION_STATUS',
    }),

    infiniteHandler($state) {
      if (!this.preloading) {
        // const jwtAccess = JSON.parse(this.authJwtToken).a;
  
        putLoadCourseList('', {
          status: 'post', // post、draft
          search: this.switchQuery === '全部' ? '' : this.switchQuery, // 搜尋關鍵字 (title、tags)
          page: this.pageIndex,
          size: this.pageSize,
        })
          .then((res) => {
            res.data.results.map((x) => this.courseData.push(x));
            console.log('LazyLoad Success', this.courseData);

            if (res.data.results.length < this.pageSize || this.courseData.length === res.data.count) {
              $state.complete();
            } else {
              this.pageIndex += 1;
            }
            $state.loaded();
          })
          .catch((err) => {
            console.log('讀取副作用清單 Error', err);
          })
      } else {
        $state.complete();
      }
    },

    handleClickSwitchQuery(query) {
      this.switchQuery = query;
      this.reloading = true;
      this.pageIndex = 1;
      this.courseData = [];

      this.axiosLoadCourseList(query);
    },

    // axiosLoadCourseOverview() {
    //   this.courseOverview = {};
    //   axios.all(
    //     [
    //       putLoadCourseList('', {
    //         status: 'post',
    //         search: this.menuList[1],
    //         page: this.pageIndex,
    //         size: this.pageSize,
    //       }),
    //       putLoadCourseList('', {
    //         status: 'post',
    //         search: this.menuList[2],
    //         page: this.pageIndex,
    //         size: this.pageSize,
    //       }),
    //       putLoadCourseList('', {
    //         status: 'post',
    //         search: this.menuList[3],
    //         page: this.pageIndex,
    //         size: this.pageSize,
    //       }),
    //       putLoadCourseList('', {
    //         status: 'post',
    //         search: this.menuList[4],
    //         page: this.pageIndex,
    //         size: this.pageSize,
    //       }),
    //       putLoadCourseList('', {
    //         status: 'post',
    //         search: '',
    //         page: 1,
    //         size: 1,
    //       }),
    //     ]
    //   )
    //   .then(axios.spread((list1, list2, list3, list4, latest) => {
    //     const preloadProcess = new Promise((resolve) => {
    //       this.courseOverview = {
    //         a: list1.data,
    //         b: list2.data,
    //         c: list3.data,
    //         d: list4.data,
    //       };
    //       this.latestData = latest.data.results[0];
    //       console.log('PRELOADING', this.latestData);
    //       return resolve();
    //     });

    //     preloadProcess.then((value) => {
    //       this.preloading = false;
    //       this.reloading = false;
    //     });
    //   }))
    //   .catch((error) => {
    //     console.log('error', error.response);
    //   });
    // },

    axiosLoadCourseList(query) {
      axios.all([
        putLoadCourseList('', {
          status: 'post', // post、draft
          search: query === '全部' ? '' : query, // 搜尋關鍵字 (title、tags)
          page: this.pageIndex,
          size: this.pageSize,
        }),
        putLoadCourseList('', {
          status: 'post',
          search: '',
          page: 1,
          size: 1,
        }),
        putLoadCourseList('', {
          status: 'draft',
          search: '',
          page: 1,
          size: 1,
        }),
      ])
      .then(axios.spread((list, latest, draft) => {
        const loadProcess = new Promise((resolve) => {
          this.courseData = list.data.results;
          this.latestData = latest.data.results[0];
          this.draftData = draft.data.results[0];
          return resolve();
        });

        loadProcess.then((value) => {
          this.preloading = false;
          this.reloading = false;
          this.pageIndex += 1;
        });
      }))
      .catch((error) => {
        console.log('error', error.response);
      });
    },
  },

  // eslint-disable-next-line vue/order-in-components
  // computed: {
  //   ...mapGetters({
    // loginDjangoId: 'user/exportUserDjangoId',
    // loginStatus: 'user/exportLoginStatus',
    // loginProfile: 'user/exportUserProfile',
    // subscribeVip: 'user/exportUserSubscribeVip',
    // authJwtToken: 'user/exportUserJwtToken',
  //   }),
  // },

  // eslint-disable-next-line vue/order-in-components
  watch: {
    $route(to, from) {    
      console.log('route', this.$route);
      this.$route.query.f ? this.handleClickSwitchQuery(this.switchQuery) : this.handleClickSwitchQuery('全部');

      // if (this.$route.query.f) {
      //   this.handleClickSwitchQuery(this.switchQuery);
      // } else {
      //   this.handleClickSwitchQuery('全部');
      // }
    },
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/course/courseMenu.scss';
</style>
